import { defineComponent as _defineComponent } from 'vue'
import { type MetricType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleKpiGoalType',
  props: {
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: MetricType
};





const handleGoalTypeChange = (val: string) => {
  emit('input', { ...props.value, defaultGoalType: val }, 'defaultGoalType')
}

const handleTargetChange = (val: string) => {
  emit('input', { ...props.value, defaultGoalTarget: parseFloat(val) }, 'defaultGoalTarget')
}

return { __sfc: true,props, emit, handleGoalTypeChange, handleTargetChange }
}

})